<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Recargas</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de Recargas</strong>
            </h5>
          </div>
        </b-row>
        <b-form>
          <b-row>
            <b-col md="4" lg="4" xl="3" class="">
              <label for="example-datepicker">Fecha inicial</label>
              <b-form-datepicker id="example-datepicker" v-model="startDate" @input="search()" placeholder="Fecha inicial" class="mb-2" value-as-date></b-form-datepicker>
            </b-col>
            <b-col md="4" lg="4" xl="3" class="">
              <label for="example-datepicker">Fecha final</label>
              <b-form-datepicker id="example-datepicker2" v-model="endDate" @input="search()" placeholder="Fecha final" class="mb-2" value-as-date></b-form-datepicker>
            </b-col>
            <b-col md="4" lg="4" xl="3" class="">
              <b-form-group id="input-group-1" label="Tipo de recarga:" label-for="input-1">
                <b-form-select v-model="form.type" :options="rechargeType"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" lg="4" xl="3" class="">
              <b-form-group id="input-group-3" label="Código de recarga:" label-for="input-3">
                <b-form-input id="input-3" v-model="form.rechargeCode" placeholder="Ingrese el código"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="4" xl="3" class="">
              <b-form-group id="input-group-2" label="Identificación:" label-for="input-2">
                <b-form-input id="input-2" v-model="form.rechargeUser" placeholder="Ingrese el nip"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4" lg="4" xl="3" class="">
              <b-form-group id="input-group-1" label="Recargador:" label-for="input-1">
                <b-form-select v-model="form.recharger" :options="roles"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
        <b-row>
          <div class="col">
            <b-table v-if="(recharges.rows).length !== 0" striped hover :fields="columns" :items="recharges.rows" head-variant="light" responsive>
              <template #cell(value)="recharge">
                {{ currencyFormat(recharge.item.value) }}
              </template>
              <template #cell(userRecharge)="recharge">
                {{ getFullName(recharge.item.userRecharge) }}
              </template>
              <template #cell(createdAt)="recharge">
                {{ showingDateFormat(recharge.item.createdAt) }}
              </template>
              <template #cell(actions)="recharge">
                <div>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Ver información</span>
                    </template>
                    <button type="button" @click="() => openModal(recharge.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto">
                      <i class="fa fa-eye" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Eliminar recarga</span>
                    </template>
                    <button type="button" v-on:click="deleteRecharge(recharge.item)" class="btn btn-light mr-2 col-md-1 col-xl-auto" v-if="hasPermission([consts.permissions.DELETE_RECHARGE])">
                      <i class="fa fa-times-circle text-red" />
                    </button>
                  </a-tooltip>
                </div>
              </template>
            </b-table>
            <empty-table v-else/>
          </div>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="search()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal id="editRecharge" ref="modal" title="Editar Recarga" hide-footer>
      <b-row class="justify-content-center">
        <b-col>
          <img :src="`${rechargeToEdit.userRecharge.pathAvatar}?tr=w-300`"
          @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
          width="200" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
      </b-row>
      <b-row class="justify-content-center ml-2">
        <b-col sm="12" md="9">
          <b>Nombre:</b> {{ getFullName(rechargeToEdit.userRecharge)}}
        </b-col>
      </b-row>
      <b-row class="ml-2">
        <b-col sm="12" md="6">
          <b>Fecha:</b> {{ showingDateFormat(rechargeToEdit.createdAt) }}
        </b-col>
        <b-col sm="12" md="6">
          <b>Identificación:</b> {{ rechargeToEdit.userRecharge.cc }}
        </b-col>
      </b-row>
      <b-row class="justify-content-center ml-2" style="padding-top: 2em;">
        <b-col style="font-size: 1.5em;">
          <b>Saldo actual:</b> {{ currencyFormat(rechargeToEdit.balance) }}
        </b-col>
      </b-row>
      <b-row class="justify-content-center ml-2">
        <b-col>
          <b>Recarga previa:</b> <b style="font-size: 1.2em;">{{ currencyFormat(rechargeToEdit.previousValue) }}</b>
        </b-col>
      </b-row>
      <b-row class="justify-content-center ml-2">
        <b-col>
          <b-form-group label="Tipo de recarga:">
            <b-form-radio-group
              :disabled="rechargeToEdit.type === consts.RECHARGE_PAYMENT_GATEWAY"
              v-model="rechargeToEdit.type"
              :options="options"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="ml-2">
        <b-col sm="12" md="12" lg="20">
          <b-form-group id="input-group-8" label="Recarga previa a editar:" label-for="input-8">
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-money text-blue" /></span>
              </div>
              <money v-model="value" v-bind="money"  :class="{ 'disabled-input': rechargeToEdit.type === consts.RECHARGE_PAYMENT_GATEWAY }" style="font-size: 1.5em;" class="form-input"></money>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="12">
          <div style="color: indianred">{{ this.msgValueToChargeValidation }}</div>
        </b-col>
        <b-col cols="12" sm="12" md="12" v-if="comboCheck">
          <b>Recarga de {{ comboName.toLowerCase() }}s previa: </b><b style="font-size: 1.2em;">{{ rechargeToEdit.previousRechargedCombos }}</b>
        </b-col>
        <b-col cols="9" sm="8" md="8" lg="8" v-if="comboCheck">
          <b-form-group id="input-group-8" :label="'Recarga de ' + comboName.toLowerCase() + 's a editar:'" label-for="input-8">
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-cutlery text-blue" /></span>
              </div>
              <b-form-input :disabled="rechargeToEdit.type === consts.RECHARGE_PAYMENT_GATEWAY" v-model="rechargeToEdit.rechargedCombos" style="font-size: 1.3em;" class="form-input input-lg border-dark" type="number" min="0"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" md="12" v-if="comboCheck">
          <div style="color: indianred">{{ this.msgValueToChargeValidationCombos }}</div>
        </b-col>
        <b-col cols="12" sm="3" md="11" style="font-size: 1.5em;">
          <b-button type="submit" variant="primary" class="my-2 mx-2" @click="validateEditRecharge()" :disabled="!chargeActiveButton || rechargeToEdit.type === consts.RECHARGE_PAYMENT_GATEWAY">Guardar</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="pull-right">
        <b-col>
          <b-form>
            <b-button @click="$bvModal.hide('editRecharge')" variant="light" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import { Money } from 'v-money'
import Swal from 'sweetalert2'
import axios from 'axios'
import emptyTable from '@/components/custom/cardEmptyList'
import { consts, currencyFormat, currencyFormatPesos, hasPermission, showErrorMessage } from '@/services/utilities'
import store from 'store'
import moment from 'moment'
import apiClient2 from '@/services/axios/v2'

export default {
  name: 'ManagementArea',
  components: { Money, emptyTable },
  data() {
    return {
      recharges: {
        count: 0,
        rows: [],
      },
      startDate: '',
      endDate: '',
      start: '',
      end: '',
      value: '',
      form: {
        rechargedCombos: '',
        rechargeCode: '',
        rechargeUser: '',
        recharger: null,
        type: null,
      },
      msgValueToChargeValidation: '',
      msgValueToChargeValidationCombos: '',
      chargeActiveButton: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false, /* doesn't work with directive */
      },
      rechargeToEdit: {
        id: '',
        idUser: '',
        value: '',
        type: '',
        previousValue: '',
        rechargedCombos: '',
        previousRechargedCombos: '',
        userRecharge: {
          firstName: '',
          secondName: '',
          firstLastName: '',
          secondLastName: '',
          cc: '',
          balance: '',
          pathAvatar: '',
        },
      },
      options: consts.RECHARGE_TYPE,
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'userRecharge.cc', label: 'Identificación' },
        { key: 'userRecharge', label: 'Nombre y Apellido' },
        { key: 'value', label: 'Valor' },
        { key: 'createdAt', label: 'Fecha' },
        { key: 'actions', label: 'Acciones' },
      ],
      roles: [
        { value: null, text: 'Seleccione un recargador' },
      ],
      rechargeType: consts.FILTER_RECHARGE_TYPE,
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      typingTimer: '',
      accessToken: '',
      comboCheck: false,
      comboName: '',
      consts: consts,
    }
  },
  computed: {
    ...mapState(['user']),
    currencyFormatBalance: function () {
      return currencyFormat()
    },
  },
  beforeRouteEnter (to, from, next) {
    function getRecharges() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setMonth(minDate.getMonth() - 1)
      const start = moment(minDate).format('YYYY-MM-DD')
      const end = moment(today).format('YYYY-MM-DD')
      const sentParams = {
        start: start,
        end: end,
        perPage: 10,
        currentPage: 0,
      }
      return apiClient.get('/recharges', { params: { sentParams: sentParams } })
    }
    function getRoles() {
      return apiClient.get('/roles')
    }
    function getCombos() {
      return apiClient2.get('/schoolParam/active')
    }
    axios.all([getRecharges(), getRoles(), getCombos()])
      .then(axios.spread(function (recharges, roles, combos) {
        next((vm) => {
          vm.setDataRecharges(null, recharges.data)
          vm.setDataCombos(null, combos.data.data)
          vm.setDataRoles(null, roles.data.results)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataRecharges(err, [])
          vm.setDataCombos(err, [])
          vm.setDataRoles(err, [])
        })
      })
  },
  watch: {
    value: function(val) {
      this.chargeActiveButton = false
      if (val % 50 !== 0) { // es multiplo de 50
        this.msgValueToChargeValidation = 'El valor a recargar debe ser multiplo de $50'
        return
      }
      if (val < 0 || val === '' || isNaN(val)) {
        this.msgValueToChargeValidation = 'El valor a recargar debe ser mayor o igual a cero (0).'
        return
      }
      this.msgValueToChargeValidation = ''
      this.chargeActiveButton = true
    },
    'form.rechargedCombos': function(val) {
      this.chargeActiveButton = false
      if (val < 0 || val === '' || isNaN(val)) {
        this.msgValueToChargeValidationCombos = 'El valor a editar debe ser mayor o igual a cero (0).'
        return
      }
      this.msgValueToChargeValidationCombos = ''
      this.chargeActiveButton = true
    },
    'form.rechargeCode': function () {
      this.getBySearchFields()
    },
    'form.rechargeUser': function () {
      this.getBySearchFields()
    },
    'form.recharger': function () {
      this.getBySearchFields()
    },
    'form.type': function () {
      this.getBySearchFields()
    },
  },
  methods: {
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    getFullName(recharge) {
      let fullName = recharge.firstName
      if (recharge.secondName !== null && recharge.secondName.length > 1) {
        fullName += ' ' + recharge.secondName
      }
      fullName += ' ' + recharge.firstLastName
      if (recharge.secondLastName !== null && recharge.secondLastName.length > 1) {
        fullName += ' ' + recharge.secondLastName
      }
      return fullName
    },
    showingDateFormat: function (date) {
      return moment(date).format('YYYY-MM-DD h:mm:ss a')
    },
    deleteRecharge(recharge) {
      Swal.fire({
        title: 'Confirmar eliminación de la Recarga',
        text: '¿Desea eliminar la recarga ' + recharge.id + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No.',
      }).then((result) => {
        if (result.isConfirmed) {
          const validateRecharge = recharge.userRecharge.balance - recharge.value
          const validateComboRecharge = recharge.userRecharge.combos - recharge.rechargedCombos
          if (validateRecharge < 0 || validateComboRecharge < 0) {
            Swal.fire('Error en la recarga', 'El saldo final no debe ser menor a 0', 'error')
          } else {
            apiClient.delete('/recharges/' + recharge.id).then(response => {
              const alertResponse = !this.comboCheck ? 'El saldo final es ' + validateRecharge : 'El saldo final es ' + validateRecharge + ' y el saldo de ' + this.comboName + 's es ' + validateComboRecharge
              Swal.fire('Recarga eliminada con éxito', alertResponse, 'success')
              this.recharges.rows = this.recharges.rows.filter(item => item.id !== recharge.id)
            }).catch(e => {
              Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
            })
          }
        }
      })
    },
    async openModal(recharge) {
      this.rechargeToEdit = recharge
      this.value = recharge.value
      this.rechargedCombos = recharge.rechargedCombos
      this.rechargeToEdit.previousValue = this.rechargeToEdit.value
      this.rechargeToEdit.previousRechargedCombos = this.rechargeToEdit.rechargedCombos
      this.rechargeToEdit.balance = this.rechargeToEdit.userRecharge.balance
      this.$bvModal.show('editRecharge')
    },
    getBySearchFields() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    setDataCombos (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.comboCheck = false
        this.comboName = 'Parametro no definido'
        for (const combo of data) {
          if (combo.key === consts.params.COMBO) {
            this.comboCheck = combo.active
            this.comboName = combo.value[0].toUpperCase() + combo.value.slice(1).toLowerCase()
            this.columns = [
              { key: 'id', label: 'Código' },
              { key: 'userRecharge.cc', label: 'Identificación' },
              { key: 'userRecharge', label: 'Nombre y Apellido' },
              { key: 'value', label: 'Valor' },
              { key: 'rechargedCombos', thClass: 'text-center', tdClass: 'text-center', label: this.comboName + 's' },
              { key: 'createdAt', label: 'Fecha' },
              { key: 'actions', label: 'Acciones' },
            ]
          }
        }
      }
    },
    setDataRecharges (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.recharges = data
        this.pagination.rows = this.recharges.count
      }
    },
    setDataRoles (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        const roles = []
        const neededRoles = [1, 2, 10, 12]
        apiClient.get('/recharges/rechargers', { params: { roles: neededRoles } }).then(response => {
          response.data.forEach(i => roles.push({ value: i.id, text: this.getFullName(i) }))
        }).catch(err => {
          this.$notification.success({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(err),
          })
        })
        roles.unshift({ value: null, text: 'Seleccione un recargador' })
        this.roles = roles
      }
    },
    search() { // Guarda un grado llamando a la API
      const sentParams = {
        rechargeCode: this.form.rechargeCode,
        rechargeUser: this.form.rechargeUser,
        recharger: this.form.recharger,
        type: this.form.type,
        start: this.startDate,
        end: this.endDate,
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage - 1,
      }
      apiClient.get('/recharges', { params: { sentParams: sentParams } }).then(response => {
        this.recharges = response.data
        this.pagination.rows = this.recharges.count
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    // Valida la recarga antes de enviar el patch
    validateEditRecharge() {
      const validateRecharge = (this.rechargeToEdit.userRecharge.balance) - (this.rechargeToEdit.previousValue - this.value)
      const validateComboRecharge = (this.rechargeToEdit.userRecharge.combos) - (this.rechargeToEdit.previousRechargedCombos - this.rechargeToEdit.rechargedCombos)
      if (validateRecharge < 0 || validateComboRecharge < 0) {
        Swal.fire('Error en la recarga', 'El saldo final no debe ser menor a 0', 'error')
      } else {
        this.rechargeToEdit.value = this.value
        this.rechargeToEdit.previousValue = this.value
        this.rechargeToEdit.userRecharge.balance = validateRecharge
        this.rechargeToEdit.userRecharge.combos = validateComboRecharge
        let sentParams = {
          id: this.rechargeToEdit.id,
          idUser: this.rechargeToEdit.idUser,
          newValue: this.value,
          newType: this.rechargeToEdit.type,
          newBalance: validateRecharge,
          newRechargedCombos: this.rechargeToEdit.rechargedCombos,
          newCombos: validateComboRecharge,
        }
        apiClient.patch('/recharges/' + this.rechargeToEdit.id, { sentParams: sentParams }).then(response => {
          const alertResponse = !this.comboCheck ? 'El saldo final es ' + validateRecharge : 'El saldo final es ' + validateRecharge + ' y el saldo de ' + this.comboName + 's es ' + validateComboRecharge
          Swal.fire('Recarga actualizada', alertResponse, 'success')
          this.search()
          this.$bvModal.hide('editRecharge')
        }).catch(err => {
          Swal.fire('Ooops ocurrio un error', showErrorMessage(err), 'error')
        })
        sentParams = {
          rechargeCode: this.form.rechargeCode,
          rechargeUser: this.form.rechargeUser,
          recharger: this.form.recharger,
          start: this.startDate,
          end: this.endDate,
          perPage: this.pagination.perPage,
          currentPage: this.pagination.currentPage - 1,
        }
        apiClient.get('/recharges', { params: { sentParams: sentParams } }).then(response => {
          this.recharges = response.data
          this.pagination.rows = this.recharges.count
        }).catch(error => {
          this.$notification.error({
            message: 'Ooops ocurrió un error /n',
            description: showErrorMessage(error),
          })
        })
      }
    },
  },
  created() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 1)
    this.startDate = minDate
    this.endDate = today
    this.accessToken = store.get('accessToken')
  },
}
</script>
<style scoped>
.disabled-input {
  pointer-events: none;
  background: #F2F4F8;
  border: 1px solid black;
  border-radius: 3px;
}
</style>
